<template lang="pug">
  .container
    .columns
      .column.is-12
        h5.title {{ responsiva.nombre_responsiva }}
    .columns
      .column.is-4
        b Fecha de Registro:&nbsp
        span {{ responsiva.fechaReg }}
      .column.is-4
        b Resguarda:&nbsp
        span {{ responsiva.usuario }}
      .column.is-4
        b Ubicación:&nbsp
        span {{ responsiva.ubicacion }}
</template>

<script>
  export default {
    name: 'CardResponsiva',
    props: {
      responsiva: {
        type: Object,
        default: () => {}
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/responsivas_Componentes/components/CardResponsiva.vue